<div class="host __dashboard" #cropper></div>